import React from 'react';
import LeadgenLoading from '../ui/LeadgenLoading.js';

/**
 * Legacy wrapper for LoadingScreen to ensure backward compatibility
 */
export default function LoadingScreen({ message = 'Loading...', fullScreen = false }) {
  return <LeadgenLoading message={message} fullPage={fullScreen} />;
}
